import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";

import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import ShopLayout from "../../../shared/layouts/shopLayout";
import Escrow from "src/packages/escrow/view/Escrow";
import SplitBill from "src/packages/splitbill/views/SplitBill";
import MainSettings from "src/shared/layouts/MainSettings";
// import TransactionsApproval from "../components/TransactionsApproval";
import MainView from "src/packages/governmentServices/view/MainView";
import InuaJamiiView from "../../../packages/inuajamii/view/InuaJamiiView";
import ShopView from "../../account-settings/view/ShopView"


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const Shop = Loadable(lazy(() => import('../view/Shop')));
const InternalFundMovement = Loadable(lazy(() => import('../../transactions/components/InternalFundMovement')));
const SendMoney = Loadable(lazy(() => import('../../transactions/components/SendMoney')));
const TransactionsStatement = Loadable(lazy(() => import('../../transactionsStatement/view/TransactionsStatement')))
const TransactionDetails = Loadable(lazy(() => import('../../transactionsStatement/view/TransactionDetails')))
const Operators = Loadable(lazy(() => import('../../users/view/Operators')));
// const BillPresentation = Loadable(lazy(() => import('../../bill-presentment/view/BillPresentation')))
const Customers = Loadable(lazy(() => import("../../users/view/Customers")))
const Beneficiary = Loadable(lazy(() => import("../../beneficiary/view/Registered")))
const Userr = Loadable(lazy(() => import("../../beneficiary/view/Userr")))
const Details = Loadable(lazy(() => import("../../beneficiary/view/Details")))
const SchoolPayments = Loadable(lazy(() => import("../../schoolpayments/view/Schooltable")))
const Merchantt = Loadable(lazy(() => import("../../beneficiary/view/Merchantt")))
const TransactionTable = Loadable(lazy(() => import("../../bill-presentment/components/TransactionTable")))
const CashBack = Loadable(lazy(() => import("../../cashBack/view/CashBack")))
const Settings = Loadable(lazy(() => import("../../shopSettings/view/Settings")))
const FintechSettings = Loadable(lazy(() => import("../../shopSettings/view/fintech")))
const TransactionsApproval = Loadable(lazy(() => import("../components/TransactionsApproval")))
const AddOperator = Loadable(lazy(() => import('./../../users/view/Addoperator')));
const MinistrySchoolPayments = Loadable(lazy(() => import("../../ministrySchoolPayments/view/MinistrySchoolPayments")))


export const ShopRoutes = [
    // Dashboard Routes
    {
        path: 'shop-dashboard',
        element: (
            <AuthGuard>
                <ShopLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'savings-account', element: <Shop /> },
            { path: 'savings-account/internal-fund-movement', element: <InternalFundMovement /> },
            { path: 'savings-account/send-money', element: <SendMoney /> },
            { path: 'savings-account/transactions-statement', element: <TransactionsStatement /> },
            { path: 'savings-account/transactions-statement/:id', element: <TransactionDetails /> },
            { path: 'savings-account/users/operators', element: <Operators /> },
            { path: 'savings-account/users/add-operator', element: <AddOperator /> },
            // { path: 'savings-account/bill-presentation', element: <BillPresentation /> },
            { path: 'savings-account/bill-transactions', element: <TransactionTable /> },
            // { path: 'savings-account/users/customers', element: <Customers /> },
            { path: 'savings-account/beneficiary/registered', element: <Beneficiary /> },
            { path: 'savings-account/beneficiary/userr', element: <Userr /> },
            { path: 'savings-account/beneficiary/details/:id', element: <Details /> },
            { path: 'savings-account/beneficiary/merchantt', element: <Merchantt /> },
            { path: 'savings-account/schoolpayments/schooltable', element: <SchoolPayments /> },
            { path: 'savings-account/cashback', element: <CashBack /> },
            { path: 'savings-account/shopsettings', element: <Settings /> },
            // { path: 'savings-account/escrow', element: <Escrow /> },
            // { path: 'savings-account/splitbill', element: <SplitBill /> },
            { path: 'fintech-settings', element: <FintechSettings /> },
            { path: 'savings-account/transactions-approval', element: <TransactionsApproval /> },
            // { path: 'savings-account/settings', element: <MainSettings /> },
            // { path: 'savings-account/apis', element: <ApiRequests /> },
            { path: 'savings-account/account-settings', element: <ShopView /> },
            { path: 'savings-account/governmentServices', element: <MainView /> },
            { path: 'savings-account/inuajamii', element: <InuaJamiiView /> },
            { path: 'savings-account/ministrySchoolPayments', element: <MinistrySchoolPayments /> },
            



        ],
    },

];